export default __webpack_public_path__ + "static/media/face.908878bb.png";